// extracted by mini-css-extract-plugin
module.exports = {"paymentsSetting":"paymentSettingsForm_paymentsSetting__R5WjM","cost":"paymentSettingsForm_cost__1wIkA","textArea":"paymentSettingsForm_textArea__W4CD7"};